import * as React from "react";
import { observer } from "mobx-react";
import * as SCMP from "../../../../components";
import { BetFinishedFrame } from "../BetFinishedFrame";
import { PulseBetProgressPeriodData } from "../../../../data/models";
import { BetProgress } from "../BetProgress";
import { OpenPulseBetViewModel } from "../../data/models";

@observer
export class OpenPulseBet extends React.Component<{
    viewModel: OpenPulseBetViewModel,
    goMsg: string,
    winMsg: string,
    isGameRunning: boolean,
    callbacks?: {
        begin?: (period: PulseBetProgressPeriodData) => any
        progress?: (period: PulseBetProgressPeriodData, progress: number, time: string) => any
        complete?: (period: PulseBetProgressPeriodData) => any
    },
    calculateState: () => void
}, {}> {

    renderWinnings(winningsData) {
        return (
            <SCMP.Winnings inputData={winningsData} onStakeChangeFading={false} />
        )
    }

    componentDidMount() {
        this.props.calculateState();
    }

    render() {
        return (
            <div className="rj-my-pulse-bets__bet-wrapper" >
                <div className="rj-my-pulse-bets__bet-wrapper-inner">
                    {this.renderWinnings(this.props.viewModel.winningsData)}
                    <BetProgress
                        colors={this.props.viewModel.trackColor}
                        segments={this.props.viewModel.pulseBetProgressData}
                        isProgressFinished={this.props.viewModel.isBetExpired()}
                        isGameInProgress={this.props.isGameRunning}
                        callbacks={this.props.callbacks}
                    />
                </div>
                {
                    this.props.viewModel.isFinished &&
                    <BetFinishedFrame
                        won={this.props.viewModel.finishedState && this.props.viewModel.finishedState.status && this.props.viewModel.finishedState.status.won}
                        actions={{ text: "string", handler: () => { } }}
                        goMsg={this.props.goMsg}
                        winMsg={this.props.winMsg}
                        removeBetHandler={() => this.props.viewModel.backToBetPlacementHandler(this.props.viewModel)} />
                }
            </div>
        )
    }
}